import Logger from '~/web-frontend-core/devtools/logger';
import { EventsMap } from '~/web-frontend-core/utils/KafkaLogger/KafkaEventsMap';
import { getConfig } from '~/web-frontend-core/config';
import { getTimeZone } from '~/web-frontend-core/utils/getTime';
export const searchEvent = (event, detail, additionalData) => {
    let info = {};
    let error = false;
    Object.keys(EventsMap).find(topic => {
        return Object.keys(EventsMap[topic]).find(eventType => {
            return Object.keys(EventsMap[topic][eventType]).find(eventCode => {
                const isEventCodeFound = eventCode === event;
                if (isEventCodeFound) {
                    const activeProjectsList = EventsMap[topic][eventType][eventCode];
                    if (!activeProjectsList.includes(getConfig('APP_NAME'))) {
                        error = true;
                        return false;
                    }
                    const timezone = getTimeZone();
                    info = {
                        topic: topic,
                        action: Object.assign({ eventType: eventType, eventCode: eventCode, timezone }, (detail && { detail })),
                        additional_data: additionalData,
                    };
                }
                return isEventCodeFound;
            });
        });
    });
    if (error) {
        Logger.getInstance().error(new Error(`[Kafka] eventCode ${event} not included for the project ${getConfig('APP_NAME').toString()}`));
        return null;
    }
    if (Object.keys(info).length == 0) {
        Logger.getInstance().error(new Error(`[Kafka] eventCode ${event} is undefined`));
        return null;
    }
    Logger.getInstance().log(`[Kafka] ${JSON.stringify(info)}`);
    return info;
};



// WEBPACK FOOTER //
// ./src/web-frontend-core/utils/KafkaLogger/SearchEvent.js